import { GridState, VirtualizedWindow } from "../DataTable.types";
import { useDataTableSelector } from "../DataTableStateProvider";
import { WindowedGridState } from "./Plugins.types";

const VIRTUAL_WINDOW_SELECTOR = (s: GridState<unknown>) => (s as WindowedGridState<unknown>).winRange;

export const useVirtualizedWindow = <T>(): VirtualizedWindow | undefined => {
  return useDataTableSelector(VIRTUAL_WINDOW_SELECTOR);
};
